import { useEffect } from 'react';
import { useAuthenticatedContext } from '@ktag/commons';
import { useTracking } from './TrackingContext';
import useAppState from '../../AppStore';

const WAIT_FOR_LOGIN = 'avWaitForLogin';
const ACTIVE_SESSION = 'avActiveSession';

export const TrackSesionExpired = () => {
  const { Tracking } = useTracking();
  const isLoggedIn = useAppState((state) => state.isLoggedIn);
  const user = useAuthenticatedContext();

  useEffect(() => {
    const activeSession = sessionStorage.getItem(ACTIVE_SESSION);
    if (!isLoggedIn) {
      sessionStorage.removeItem(ACTIVE_SESSION);
    }

    if (activeSession && !isLoggedIn && user) {
      Tracking.Login.sessionExpired();
      sessionStorage.removeItem(ACTIVE_SESSION);
    }
    if (isLoggedIn && user) sessionStorage.setItem(ACTIVE_SESSION, 'true');
  }, [isLoggedIn, user]);
  return undefined;
};

// This component sets the LoginInitialized flag in the session storage
// to track the login event when the user returns from the login page.
export const TrackLogin = () => {
  const { Tracking } = useTracking();
  const isLoggedIn = useAppState((state) => state.isLoggedIn);
  //   const isInitialized = useRef(false);
  useEffect(() => {
    if (!isLoggedIn) return;

    const loginInitialized = sessionStorage.getItem(WAIT_FOR_LOGIN);
    sessionStorage.removeItem(WAIT_FOR_LOGIN);
    if (loginInitialized === 'true') {
      Tracking.Login.login();
    }
  }, [isLoggedIn]);

  useEffect(() => {
    if (isLoggedIn) {
      sessionStorage.removeItem(WAIT_FOR_LOGIN);
      return undefined;
    }
    const loginButton = document.getElementById('header__control--userinfo');
    const loginClickHandler = () => {
      Tracking.Login.loginInitialized();
      sessionStorage.setItem(WAIT_FOR_LOGIN, 'true');
    };
    loginButton?.addEventListener('click', loginClickHandler);

    return () => {
      loginButton?.removeEventListener('click', loginClickHandler);
    };
  }, [isLoggedIn]);
  return undefined;
};
